import { render } from "./MembershipLevels.vue?vue&type=template&id=1225b708"
import script from "./MembershipLevels.vue?vue&type=script&lang=js"
export * from "./MembershipLevels.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\digitaldistribution.io-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__